module.exports = __webpack_public_path__ + "img/newicon9click.527c9741.svg";